import { getInstance } from "../utils/helpers";

function getCountries() {
  const url = `/api/v1/countries/list`;
  return getInstance().get(url);
}

export { getCountries };
